export default
'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 85 85" xml:space="preserve">' +
'<path d="M42.5,0C19,0,0,19,0,42.5S19,85,42.5,85S85,66,85,42.5S66,0,42.5,0z M60.1,66H46.7l-4.1-31.6h-0.1L38.3,66H24.9l-8-47.1' +
'h11.9l3.7,32.6h0.1L37,19H48l4.8,32.6H53L56.3,19h11.9L60.1,66z"/>' +
'</svg>';
